module.exports = "/packs/media/images/onboarding-diy-cc67694cc3c82e31e070a11a32a014ba.png";